<template>
    <div v-show="false">
        <img id="ai-img" :src="logoUrl">
        <canvas id="ai-canvas" width="1024" height="1024"></canvas>
    </div>
</template>

<script>
export default {
    name: 'ImageProcessing',
    props: {
        logoId: {
            type: Number,
            default: null
        }
    },
    data () {
        return {
            logoUrl: null,
            maxPixels: 4000000 // maximum number of pixels supported by the SD background remove
        }
    },
    mounted () {
        this.$emit('canvasmounted', false);
    },
    watch: {
        logoId() {
            this.processImage(false, '0') // the background isn't removed the first time an image is loaded
        }
    },
    methods: {
        processImage(removeBackground, ratioThreshold) {
            const img = window.document.getElementById('ai-img')

            img.onload = () => this.imageOnload(img, ratioThreshold)
            
            if (this.logoId >= 0) {
                if (removeBackground) this.logoUrl = window.Urls['logo_get_logo_img_bg'](this.logoId)
                else this.logoUrl = window.Urls['logo_get_logo_img'](this.logoId)

                img.src = this.logoUrl
            }
        },
        imageOnload(img, ratioThreshold) {
            const canvas = window.document.getElementById("ai-canvas")
            const context = canvas.getContext("2d")

            let hRatio = canvas.width / img.width
            let vRatio = canvas.height / img.height
            
            if (typeof(ratioThreshold) === 'string') {
                ratioThreshold = parseFloat(ratioThreshold)
            }
            
            let ratio = Math.min(hRatio, vRatio) + ratioThreshold

            let centerShift_x = (canvas.width - img.width * ratio) / 2
            let centerShift_y = (canvas.height - img.height * ratio) / 2

            context.clearRect(0, 0, canvas.width, canvas.height)

            context.drawImage(
                img,
                0, 0, img.width, img.height,
                centerShift_x, centerShift_y, img.width * ratio, img.height * ratio
            )
            
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height)

            context.putImageData(imageData, 0, 0)

            canvas.toBlob((blob) => {
                this.$emit('blobLoaded', blob)
            }, 'image/png')
        },
        resizeImage(binaryData) {
            const blob = new Blob([binaryData], { type: 'image/jpeg' })
    
            const img = new Image()

            const promise = new Promise((resolve, reject) => {
                img.onload = () => {
                    const canvas = document.createElement('canvas')
                    const ctx = canvas.getContext('2d')
                    
                    const scaleFactor = Math.sqrt(this.maxPixels / (img.width * img.height))
                    const newWidth = img.width * scaleFactor
                    const newHeight = img.height * scaleFactor

                    canvas.width = newWidth
                    canvas.height = newHeight
                    
                    ctx.drawImage(img, 0, 0, newWidth, newHeight)
                    
                    canvas.toBlob((blob) => {
                        resolve(blob)
                    }, 'image/jpeg')
                }

                img.onerror = reject
            })

            img.src = URL.createObjectURL(blob)

            return promise
        }
    }
}
</script>